import { CheckboxMenuComponent } from "./checkboxMenu";

export const CheckboxMenu = CheckboxMenuComponent;
